import React from 'react'

export const ArrowTriangleDown = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='14'
    height='7'
    viewBox='0 0 14 7'
    {...props}
  >
    <path
      fill-rule='evenodd'
      clip-rule='evenodd'
      d='M6.99991 6.9995C6.77191 6.9995 6.54491 6.9225 6.35991 6.7675L0.359909 1.7675C-0.0640909 1.4145 -0.122091 0.783495 0.231909 0.359495C0.584909 -0.0645046 1.21491 -0.121505 1.63991 0.231495L7.01091 4.7075L12.3729 0.392495C12.8029 0.0464955 13.4329 0.114495 13.7789 0.544495C14.1249 0.974495 14.0569 1.6035 13.6269 1.9505L7.62691 6.7785C7.44391 6.9255 7.22191 6.9995 6.99991 6.9995Z'
    />
  </svg>
)